import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { ValidaArquivoModule } from '../app/apps/valida-arquivo/valida-arquivo.module';
import { environment } from '../environments/environment';

if (environment.production) {
    enableProdMode();
}

document.title = 'Verificação de Documento';

window.addEventListener('dragover', event => event.preventDefault(), false);
window.addEventListener('drop', event => event.preventDefault(), false);

platformBrowserDynamic().bootstrapModule(ValidaArquivoModule);
